// bazaar — or. Part of the or i18n bundle; merged by ./index.js

export default {
  bazaarTitle: 'Baazaara',
  bazaarSubtitle: "Oomishaalee gurgurtootaa hunda bakka tokkotti ilaali",
  bazaarMarketplaceWord: 'Baazaara',
  bazaarClosedDesc: 'All Things Baazaara amma closedha jira. Daldalaa daawwadhuuf gurgurtootaa keenya hayyama qaban waliin gadhiiftooda sochoa.',
};

